import type { SvgIconPropsWithChildren } from '../components/SvgIcon/index.js';

import React, { createElement } from 'react';

import { SvgIcon } from '../components/SvgIcon/index.js';

function SvgFirst(props: SvgIconPropsWithChildren) {
  return createElement(
    SvgIcon,
    props,
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        id="Vector"
        d="M10.3981 12.2525L19.7762 22.3353C19.9172 22.4895 19.9959 22.6973 19.995 22.9135C19.9942 23.1297 19.9139 23.3368 19.7717 23.4897C19.6294 23.6426 19.4368 23.7289 19.2357 23.7297C19.0346 23.7306 18.8413 23.6459 18.6979 23.4943L8.852 12.9088C8.68428 12.7285 8.61109 12.4856 8.63218 12.2503C8.62181 12.1305 8.63616 12.0098 8.6742 11.8966C8.71224 11.7834 8.77304 11.6807 8.85226 11.5957L18.6984 1.01023C18.8414 0.856505 19.0353 0.770142 19.2376 0.770142C19.4398 0.770142 19.6337 0.856505 19.7767 1.01023C19.9197 1.16396 20 1.37246 20 1.58986C20 1.80726 19.9197 2.01576 19.7767 2.16949L10.3981 12.2525Z"
        fill="#727272"
      />
      <path
        id="Vector_2"
        d="M1.76846 12.2525L11.1473 22.3353C11.2883 22.4895 11.367 22.6973 11.3661 22.9135C11.3653 23.1297 11.285 23.3368 11.1428 23.4897C11.0006 23.6426 10.8079 23.7289 10.6068 23.7297C10.4057 23.7306 10.2124 23.6459 10.069 23.4943L0.223115 12.9088C0.0553913 12.7285 -0.0177975 12.4856 0.0032959 12.2503C-0.00705814 12.1305 0.00729561 12.0098 0.0453348 11.8966C0.083375 11.7835 0.144164 11.6807 0.223369 11.5957L10.069 1.01023C10.212 0.856505 10.4059 0.770142 10.6082 0.770142C10.8104 0.770142 11.0043 0.856505 11.1473 1.01023C11.2903 1.16396 11.3706 1.37246 11.3706 1.58986C11.3706 1.80726 11.2903 2.01576 11.1473 2.16949L1.76846 12.2525Z"
        fill="#727272"
      />
    </svg>
  );
}
export default SvgFirst;
